/* External dependencies */
import { API } from 'aws-amplify';

/* Internal dependencies */
import { ApiName } from '../aws-exports';

export const listBeatmatchEvents = async () =>
  await API.get(ApiName.bmApp, `/events/listBeatmatchEvents`, null);